import React, { useState } from 'react';

export function AcordeonContent({ faqItems }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className=" pl-10">
      <h2 className="text-3xl font-bold text-[#e8f2f4] mb-10 text-center" style={{ textShadow: '2px 3px 4px rgba(0,0,0,0.4)' }}>Preguntas frecuentes</h2>
      <div className="space-y-2">
        {faqItems.map((item, index) => (
          <div key={index} className="bg-[#cfe3fb] rounded-md p-4 cursor-pointer" onClick={() => toggleAccordion(index)}>
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-bold text-[#032c65]">{item.question}</h3>
              <span className="text-[#032c65] text-2xl">{openIndex === index ? "↑" : "↓"}</span>
            </div>
            {openIndex === index && <p className="text-[#365a8b] my-5 font-bold">{item.answer}</p>}
          </div>
        ))}
      </div>
      <p className="text-[#cfe3fb] font-bold text-xl mt-10">
        ¿Necesitas más información?, puedes dar clic aquí para ver más preguntas frecuentes o si prefieres da clic aquí para contactar a uno de nuestros asesores.
      </p>
    </div>
  );
}
